import module from './core.module'

export default module.name
